import React, {Component} from "react";
import { Link, Navigate } from "react-router-dom";
import axiosBaseURL from "../httpCommon";

class Organizations extends Component {
constructor(props){
        super();
        this.state={
            organizations: [],
            redirect: false,
            loggedIn: window.localStorage.getItem("isLoggedIn"),
            authUser: JSON.parse(window.localStorage.getItem("userData"))
        }
    }

    async componentDidMount(){

        await axiosBaseURL.get('api/v1/organizations', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if (response.data.status === 200) {
                    this.setState({
                        organizations: response.data.organizations
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render (){
        if(!this.state.loggedIn === true){
            return <Navigate to ="/login"/>
        }

        const allOrganizations = this.state.organizations
        const printOrganizations = allOrganizations.map((allOrganization, key) => {
            return <div key={key}>
                <div className="col-12">
                    <div className="product-inline">
                        <Link to={"/organization/" + allOrganization.id}>
                            <img src={allOrganization.picture} className="img-fluid" alt=""/>
                        </Link>
                        <div className="product-inline-content">
                            <div>
                                <Link to={"/organization/" + allOrganization.id}>
                                    <h4>{allOrganization.name}</h4>
                                </Link>
                                <h5>{allOrganization.address}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            <div className="divider"></div>
        </div>
        });

        return(
            <>
            <header>
                <div className="back-links">
                    <Link to={"/"}>
                        <i className="iconly-Arrow-Left icli"></i>
                        <div className="content">
                            <h2>My Organizations</h2>
                        </div>
                    </Link>
                </div>
                <div className="header-option">
                    <ul>
                        <li>
                            <Link to={"/"}><i className="iconly-Home icli"></i></Link>
                        </li>
                    </ul>
                </div>
            </header>


  <section className="deals-section px-15 pt-0">
    <div className="title-part">
      <h2>My Datas</h2>
    </div>
    <div className="product-section">
      <div className="row gy-3">
        
        
{this.state.organizations.length > 0 ?
            printOrganizations
            :
            (<div><p className="">You have No Organization Available.</p></div>)
        }
        
      </div>
    </div>
  </section>


  <section className="panel-space"></section>


            </>
        );
    }
}

export default Organizations;